export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";